import axios from "../utils/axiosConfig";
import {
  ISubscriptionPlan,
  IOrganizationSubscription,
  IInvoiceUsage,
} from "../Interfaces/ISubscription"
const { BASE_URL } = require("../utils/urls");
// API URL
const API_URL=`${BASE_URL}/api`;
export interface ICurrentSubscriptionResponse {
  success: boolean;
  subscription: IOrganizationSubscription | null;
  plan: ISubscriptionPlan | null;
  isActive: boolean;
  isExpired: boolean;
}

export const getCurrentSubscription = async (): Promise<ICurrentSubscriptionResponse> => {
  const response = await axios.get(`${API_URL}/subscription/current`);
  return response.data;
};

export const getInvoiceUsage = async (): Promise<IInvoiceUsage> => {
  const response = await axios.get(`${API_URL}/subscription/usage`);
  return response.data.invoice;
};

export const getAvailablePlans = async (): Promise<ISubscriptionPlan[]> => {
  const response = await axios.get(`${API_URL}/subscription/plans`);
  return response.data.plans;
};